export const STATE_ZERO_OID = 'state-zero';
export const pxQuestionsAnswerTypes: { [key: string]: string } = {
    PERSONAL_BROKERAGE_ACCOUNT: 'PERSONAL_BROKERAGE_ACCOUNT',
    ROBO_PERSONAL_BROKERAGE_ACCOUNT: 'ROBO_PERSONAL_BROKERAGE_ACCOUNT',
    COMPLETE: 'COMPLETE',
}
export const UTM_CAMPAIGNS_PERSONAL_PORTFOLIO = [ 'foo' ];